export default __webpack_public_path__ + "static/media/juice-fruit-product-l-desktop@3x.ab0bcfb5.png";